import React from "react";
import UseTitle from "../../components/useTitle";
import "./CharacterFull.scss";

const CharacterFull = ({
  isAdmin,
  userId,
  isMJ,
  character,
  setIsUsedXP,
  setIsUpdate,
  setIsDelete,
}) => {
  // Définition du titre de la page
  UseTitle("Fiche du personnage " + (character?.name || ""));

  // Récupération des jobs du personnage
  const jobs = character.jobs;

  // Regroupement des jobs par sources (region, parent, commun, all)
  const groupedJobs = jobs.reduce((groupedBySource, job) => {
    const source = job.source;

    // Création du groupe s'il n'existe pas
    if (!groupedBySource[source]) {
      groupedBySource[source] = [];
    }
    // Ajout du job au groupe
    groupedBySource[source].push(job);

    // console.log(groupedBySource);
    return groupedBySource;
  }, {});

  // Tri des jobs par id dans chaque groupe
  for (const source in groupedJobs) {
    groupedJobs[source].sort((a, b) => a.id - b.id);
  }

  return (
    <>
      <div className="character-full">
        {/* Header du personnage */}
        <div className="header">
          <h1>{character.name}</h1>
          {character.nickname && (
            <p className="nickname">"{character.nickname}"</p>
          )}
          <p className="owner">Propriétaire : {character.user_name}</p>
        </div>

        {/* Informations du personnage */}
        <section className="character-section">
          <h2>Informations générales</h2>
          <div className="info">
            <p>Race : {character.race}</p>
            <p>Genre : {character.gender}</p>
            <p>Age : {character.age}</p>
            <p>Beauté : {character.beauty}</p>
          </div>

          {character.description && (
            <p className="description">Description : {character.description}</p>
          )}

          <div className="stats">
            <p>PV : {character.pv}</p>
            <p>PM : {character.pm}</p>
            <p>Volonté : {character.willpower}</p>
            <p>Points d'héroïsme : {character.heroism_points}</p>
            <p>XP : {character.xp}</p>
          </div>
        </section>

        {/* Attributs */}
        <section className="character-section">
          <h2>Attributs</h2>
          <div className="attributes">
            {character.attributes.map((attribute) => (
              <div className="attribute" key={attribute.attribute_code}>
                <span className="attribute-name">{attribute.attribute}</span>
                <span className="attribute-value">
                  <strong>{attribute.current_value}</strong>
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* Métiers par source */}
        <section className="character-section">
          <h2>Métiers</h2>
          {["region", "parent", "commun", "all"].map(
            (source) =>
              groupedJobs[source] && (
                <div className="job-group" key={source}>
                  <h3>{source}</h3>
                  <div className="jobs">
                    {groupedJobs[source].map((job) => (
                      // Affichage des jobs
                      <article className="job" key={job.id}>
                        <h4>{job.name}</h4>

                        {/* Affichage des skills */}
                        {job.skills.length > 0 && (
                          <div className="skills">
                            <h5>Compétences ({job.skills.length})</h5>
                            <ul>
                              {job.skills.map((skill) => (
                                <li key={skill.id} className="skill">
                                  <span>
                                    {skill.name} (
                                    {skill.attributs
                                      .map((attr) => attr.name)
                                      .join(", ")}
                                    )
                                  </span>
                                  <span>
                                    <strong>{skill.value}</strong>
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {/* Affichage des spells */}
                        {job.spells.length > 0 && (
                          <div className="spells">
                            <h5>Sorts ({job.spells.length})</h5>
                            <ul>
                              {job.spells.map((spell) => (
                                <li key={spell.id} className="spell">
                                  <span>
                                    {spell.name} (
                                    {spell.attributs
                                      .map((attr) => attr.name)
                                      .join(", ")}
                                    )
                                  </span>

                                  <span>
                                    {spell.value}/{spell.value_max}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </article>
                    ))}
                  </div>
                </div>
              )
          )}
        </section>

        {/* Boutons */}
        <div className="buttons">
          {(isAdmin || isMJ) && (
            <>
              <button className="bt" onClick={() => setIsUpdate(true)}>
                Améliorer
              </button>
            </>
          )}

          {(userId === character.id_user || isAdmin) && (
            <>
              <button className="bt" onClick={() => setIsUsedXP(true)}>
                Utiliser XP
              </button>

              <button className="bt" onClick={() => setIsDelete(true)}>
                Supprimer
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CharacterFull;
